import SEO, { breadcrumbSchema } from "../components/SEO";
import PageHero from "../components/PageHero";
import CtaBand from "../components/CtaBand";
import { CityCard, SectionHead } from "../components/Cards";
import { DESTINATIONS, IMAGES_SAFE } from "../data/content";
import { IMAGES } from "../data/site";

export default function AllRajasthan() {
  return (
    <>
      <SEO
        title="Taxi Service Across Rajasthan — All Cities & Destinations"
        description="Blue City Taxi provides taxi service across Rajasthan — Jodhpur, Jaipur, Udaipur, Jaisalmer, Mount Abu, Ajmer, Pushkar, Bikaner, Ranthambore & 15 more destinations. Call 094602 05326."
        path="/all-rajasthan-taxi"
        schemas={[breadcrumbSchema([{ name: "Home", path: "/" }, { name: "All Rajasthan Taxi", path: "/all-rajasthan-taxi" }])]}
      />
      <PageHero
        title="Taxi Service Across Rajasthan"
        subtitle="One trusted cab partner for the whole state — 23 destinations from the Blue City to the Golden Fort, hill station to tiger reserve."
        image={IMAGES.mehrangarh}
        crumbs={[{ label: "Home", to: "/" }, { label: "All Rajasthan Taxi" }]}
      />
      <section className="max-w-7xl mx-auto px-6 py-16">
        <SectionHead
          eyebrow="23 Destinations"
          title="Where in Rajasthan Shall We Drive You?"
          text="Tap any city to see its dedicated taxi page, or message us a custom multi-city route."
        />
        <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5">
          {DESTINATIONS.map((d, i) => <CityCard key={d.name} d={d} i={i} />)}
        </div>
      </section>
      <CtaBand title="Planning a multi-city Rajasthan trip?" text="Share your dates and wishlist — we'll plan the route, car and driver for the whole journey." />
    </>
  );
}
